module.exports = __webpack_public_path__ + "img/materiel.8b98b16f.svg";